export const enum ADDRESS_BAR_STYLE {
  SEARCH_BAR,
  SEARCH_BAR_MODAL,
  PIN_HEADER,
  PIN_INLINE,
}
